export default "__VITE_ASSET__c6d9483a__"